import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from './LoadingIcon';

const LoadingButton = ({
    onClick, text, isLoading, disabled, className, iconColour, id, type,
}) => {
    let icon = null;
    let shouldBeDisabled = disabled;

    if (isLoading) {
        icon = (
            <LoadingIcon
                colour={ iconColour }
            />
        );
        shouldBeDisabled = true;
    }

    return (
        <button
            className={ `${className} ${shouldBeDisabled ? 'is-disabled' : ''}` }
            onClick={ onClick }
            disabled={ shouldBeDisabled }
            id={ id }
            type={ type }
        >
            { icon }
            { text }
        </button>
    );
};

LoadingButton.defaultProps = {
    isLoading: false,
    disabled: false,
    className: 'btn btn--secondary',
    iconColour: '#fff',
    id: null,
    onClick: null,
    type: 'submit',
};

LoadingButton.propTypes = {
    text: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    iconColour: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

export default LoadingButton;
